export interface ExpirableStorageItem<T> {
    value: T;
    expiresAt: number;
}

export default class LocalStorageUtils {
    static setExpirableItem<T>(
        key: string,
        value: T,
        expiration: number | Date
    ): ExpirableStorageItem<T> {
        const expirableItem: ExpirableStorageItem<T> = {
            value,
            expiresAt: new Date(expiration).getTime(),
        };

        localStorage.setItem(key, JSON.stringify(expirableItem));

        return expirableItem;
    }

    static getExpirableItem<T>(key: string): T | null {
        const expirableItem: ExpirableStorageItem<T> | null = JSON.parse(
            localStorage.getItem(key) || 'null'
        );

        if (!expirableItem) {
            return null;
        }

        const now = new Date().getTime();

        if (expirableItem.expiresAt < now) {
            localStorage.removeItem(key);
            return null;
        }

        return expirableItem.value;
    }

    static removeItem(key: string): void {
        localStorage.removeItem(key);
    }
}
